import { useParams } from 'react-router-dom';

import { NotFound404, FullScreenLoading } from '@backrs_ui/common-ui';

import { usePageTitle } from '@backrs_ui/grow-ui/src/hooks/usePageTitle';
import { useGetCompetencyBySlugQuery } from '@backrs_ui/grow-ui/src/redux/contentCompetency/contentCompetency.api';
import { useGetContentByCompetencyQuery } from '@backrs_ui/grow-ui/src/redux/contentNugget/contentNugget.api';
import { useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';

import { CompetencyPage } from './CompetencyPage';
import { useAgentContext } from './CompetencyPageContainer.agentContext';

export const CompetencyPageContainer = () => {
  const { slug } = useParams<{ slug: string }>();

  const { contentCompetencies, loading: contentCompetenciesLoading } = useAppSelector(
    (state) => state.contentCompetency,
  );

  const contentCompetency = contentCompetencies.find((competency) => competency.slug === slug);

  const { data: competencyDetail } = useGetCompetencyBySlugQuery(slug ?? '', {
    skip: !slug,
  });

  const competencyCategoryName = useAppSelector(
    (state) =>
      state.contentCategory?.contentCategories?.find(
        (category) => category.id === contentCompetency?.content_category_id,
      )?.title,
  );

  const { data: contentData, isLoading: nuggetsLoading } = useGetContentByCompetencyQuery(
    {
      competency_id: contentCompetency?.id.toString() || '',
      include: 'tools,playlists',
    },
    {
      skip: !contentCompetency?.id,
    },
  );

  const isLoading = contentCompetenciesLoading || nuggetsLoading;

  useAgentContext(
    contentCompetency,
    competencyCategoryName,
    contentData?.nuggets?.length,
    contentData?.tools?.length,
    contentData?.playlists?.length,
  );

  usePageTitle(contentCompetency?.title);

  if (isLoading) {
    return <FullScreenLoading />;
  }

  if (!contentCompetency || !competencyCategoryName) {
    return <NotFound404 />;
  }

  return (
    <CompetencyPage
      categoryName={competencyCategoryName}
      contentCompetency={{
        ...contentCompetency,
        media_url: competencyDetail?.media_url ?? contentCompetency.media_url,
      }}
      nuggets={contentData?.nuggets || []}
      tools={contentData?.tools || []}
      playlists={contentData?.playlists || []}
    />
  );
};
